import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

export const SquadContentBlock = styled(Container).attrs({
  maxWidth: 600,
})`
  flex: 1;
  @media ${tabletAndAbove} {
    min-height: max(12vh, 400px);
    flex: none;
  }
`;

export const SquadFooter = styled(Container).attrs({
  maxWidth: 600,
})`
  padding: var(--double-unit) 0;
`;

export const SquadDropdownMenuRoot = styled(Vertical).attrs({ gap: 0 })`
  background: var(--c-black);
  border: 1px solid var(--c-nd-150);
  border-radius: 12px;
  overflow: hidden;
  padding: var(--half-unit);
`;

export const SquadDropdownMenuItem = styled(ButtonBase)`
  display: block;
  padding: var(--unit) var(--intermediate-unit);
  border-radius: var(--unit);
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: rgba(var(--c-rgb-white), 0.05);
  }
`;
